import { BRANDS, useBrand } from './useBrand';

const ALL_AVAILABLE = {
  vendorSchool: true,
  shop: true,
  services: true,
  hwt: true,
  faq: true,
  supportInfo: true,
  fullAddress: true,
  omni: true
};

export type BrandFeatures = typeof ALL_AVAILABLE;

export function useBrandFeatures(): BrandFeatures {
  const brand = useBrand();
  switch (brand) {
    case BRANDS.AV:
      return ALL_AVAILABLE;
    case BRANDS.ECOSU:
      return {
        ...ALL_AVAILABLE,
        fullAddress: false,
        vendorSchool: false,
        faq: false
      };
    case BRANDS.WODOMAT:
      return {
        vendorSchool: false,
        services: false,
        shop: false,
        hwt: false,
        faq: false,
        supportInfo: false,
        fullAddress: false,
        omni: false
      };
    default: {
      const exhaustiveCheck: never = brand;
      throw new Error(`Unhandled Enum case: ${exhaustiveCheck as string}`);
    }
  }
}
